import { render, staticRenderFns } from "./HandleRoleTabAbilities.vue?vue&type=template&id=15447e7e"
import script from "./HandleRoleTabAbilities.vue?vue&type=script&lang=js"
export * from "./HandleRoleTabAbilities.vue?vue&type=script&lang=js"
import style0 from "./HandleRoleTabAbilities.vue?vue&type=style&index=0&id=15447e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports